<template>
  <div
    :class="{
      'no-divider': !showDividingBorder,
    }"
    class="all:flex joined"
  >
    <slot />
  </div>
</template>

<script>
/**
 * Wrap two inputs in this component to allow them to sit closely
 * next to each other and look more like a single component.
 */
export default {
  name: 'JoinedInputWrapper',
  props: {
    showDividingBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.joined {
  > :first-child:deep(fieldset) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none !important;
  }

  > :last-child:deep(fieldset) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.no-divider {
    > :last-child:deep(fieldset) {
      border-left: none !important;
    }
  }
}
</style>
